module.exports = __webpack_public_path__ + "static/media/img3-2.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/P/img3-2.png
// module id = 2265
// module chunks = 3